module.exports = __webpack_public_path__ + "static/img/dd-customer-05.8a819f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/dd-customer-05.jpg
// module id = T6vM
// module chunks = 1